import React from "react";
import Secheader from "./common/Secondaryheader";
import Teams from "../data/Teamsdata";


const Tcards = (props) => {
	return (

		<figure className="figure col-md-4 text-center">
			<img src={props.timage} className="figure-img img-fluid rounded col-lg-6 col-7 col-md-10" alt="team3" />
			  <figcaption className="figure-caption text-dark">{props.ttitle}</figcaption>
		</figure>
	);
};

const About = () => {
	return (
		<>

		<Secheader 
			sectitle="About" 
			secdesc="Pioneering Tomorrow Through Innovation and Technology." 
		/>

		<section>
			<div className="container mx-auto py-5 col-lg-10 col-xl-9">
				<div className="mb-5 text-center">
					<p className="display-6 mb-1">Who We Are?</p>
					<p className="text-muted">Introducing ByteSkull: Innovators and Visionaries</p>
				</div>
				<p>We are ByteSkull, more than just a technology company. We are architects of innovation, driven by diversity and creativity to engineer solutions that truly make a difference. Our primary focus is delivering value to our clients and partners by merging technology with real-world insights.</p>
				<p>We hold integrity, transparency, and an insatiable thirst for knowledge as our guiding principles. Beyond our love for technology, we're visionaries who believe in its capacity to shape a brighter future.</p>
			</div>
		</section>

		<section className="bg-light">
			<div className="container row py-5 m-auto col-lg-10 col-xl-9">
				<p className="display-6 text-center mb-4">Our Story</p>
				<p>At ByteSkull Technologies, our journey began with a shared vision and a passion for innovation. Established with the belief that technology has the power to reshape industries and drive meaningful change, we embarked on a path to create solutions that inspire transformation. Our story is one of evolution, driven by a relentless pursuit of excellence and a commitment to pushing boundaries.</p>
				<p>From humble beginnings, we have grown into a dynamic force in the tech world, making our mark through cutting-edge digital solutions that redefine how businesses operate and communicate. Every challenge we encountered became an opportunity to learn, adapt, and innovate, solidifying our position as a catalyst for digital evolution.</p>
			</div>
		</section>

		<section>
			<div className="container py-5 m-auto">
				<div className="mb-4">
					<p className="display-6 text-center mb-1">Our Team</p>
					<p className="d-lg-block d-none col-8 m-auto text-center text-muted">Diverse Minds, Unified Passion, Boundless Innovation.</p>
				</div>
				<div className="row col-lg-11 d-flex align-items-center justify-content-evenly m-auto">
						{
							Teams.map((val, ind) => {
								return <Tcards key={ind}
									timage={val.timage}
									ttitle={val.ttitle}
								/>
							})
						}
				</div>
			</div>
		</section>
		
		</>
	);
};

export default About;